import type { InputOtpProps } from "primevue/inputotp"

export default {
    root: {
        class: [
            // Alignment
            "flex items-center",
            "gap-2",
        ],
    },
    input: {
        root: ({
            props,
            parent,
        }: {
            props: InputOtpProps
            parent: unknown
        }) => ({
            class: [
                // Font
                "font-sans leading-none",

                // Flex & Alignment
                { "flex-1 w-[1%]": parent.instance.$name === "InputGroup" },
                "text-center",

                // Spacing
                "m-0",
                "p-3",

                // Size
                "w-10",

                // Shape
                { "rounded-md": parent.instance.$name !== "InputGroup" },
                {
                    "first:rounded-l-md rounded-none last:rounded-r-md":
                        parent.instance.$name === "InputGroup",
                },
                {
                    "border-0 border-y border-l last:border-r":
                        parent.instance.$name === "InputGroup",
                },

                // Colors
                "text-surface-600 dark:text-surface-200",
                "placeholder:text-surface-400 dark:placeholder:text-surface-500",
                "bg-surface-0 dark:bg-surface-900",
                "border",
                {
                    "border-surface-300 dark:border-surface-600":
                        !props.invalid,
                },

                // Invalid State
                { "border-red-500 dark:border-red-400": props.invalid },

                // States
                {
                    "hover:border-primary-500 dark:hover:border-primary-400":
                        !props.disabled && !props.invalid,
                    "focus:outline-none focus:outline-offset-0 focus:ring focus:ring-primary-500/50 dark:focus:ring-primary-400/50 focus:z-10":
                        !props.disabled,
                    "opacity-60 select-none pointer-events-none cursor-default":
                        props.disabled,
                },

                // Filled State *for FloatLabel
                {
                    filled:
                        parent.instance?.$name === "FloatLabel" &&
                        props.variant === "filled",
                },

                // Misc
                "appearance-none",
                "transition-colors duration-200",
            ],
        }),
    },
}
